import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'app-generic-editor',
  templateUrl: './generic-editor.component.html',
  styleUrls: ['./generic-editor.component.scss']
})
export class GenericEditorComponent implements AfterViewInit {
  @Input() alignRow: boolean = false;
  @Input() autoFlow: boolean = false;
  @Input() autoFlowWidthThreshold: number = 850;
  bigStyle: SafeStyle;

  get shouldFlow() {
    return this.alignRow || this.forceRowFlow;
  }

  @ViewChild('container') containerElement: ElementRef;
  forceRowFlow: boolean = true;

  constructor() { }

  ngAfterViewInit(): void {
    setInterval(() => {
      const containerRect = this.containerElement.nativeElement.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const contaienrHeight = containerRect.height;
      this.bigStyle = `max-height: ${contaienrHeight}px;`;
      if (!this.autoFlow) {
        return;
      }
      this.forceRowFlow = containerWidth < this.autoFlowWidthThreshold;
    }, 100);
  }

}
